import React from 'react';
import { MdOutlineCancel } from 'react-icons/md';

import { Button } from '.';
import { useAuth } from '../contexts/AuthProvider';
import { useStateContext } from '../contexts/ContextProvider';

const UserProfile = () => {
  const { logout, authData } = useAuth();
  const { handleClick } = useStateContext();

  const handleLogout = () => {
    handleClick(null);
    logout();
  }

  return (
    <div className="nav-item absolute right-1 top-16 bg-white dark:bg-[#42464D] p-8 rounded-lg w-96">
      <div className="flex justify-between items-center">
        <p className="font-semibold text-lg dark:text-gray-200">Perfil de usuario</p>
        <Button
          icon={<MdOutlineCancel />}
          color="rgb(153, 171, 180)"
          bgHoverColor="light-gray"
          size="2xl"
          borderRadius="50%"
        />
      </div>
      <div className="flex gap-5 items-center mt-6 border-color border-b-1 pb-6">
        <div>
          <p className="font-semibold text-xl dark:text-gray-200 capitalize"> {authData.username} </p>
          <p className="text-gray-500 text-sm dark:text-gray-400">  Administrador   </p>
          {/*<p className="text-gray-500 text-sm font-semibold dark:text-gray-400"> info@shop.com </p>*/}
        </div>
      </div>
      {/** 
      <div>
        {userProfileData.map((item, index) => (
          <div key={index} className="flex gap-5 border-b-1 border-color p-4 hover:bg-light-gray cursor-pointer  dark:hover:bg-[#42464D]">
            <button
              type="button"
              style={{ color: item.iconColor, backgroundColor: item.iconBg }}
              className=" text-xl rounded-lg p-3 hover:bg-light-gray"
            >
              {item.icon}
            </button>

            <div>
              <p className="font-semibold dark:text-gray-200 ">{item.title}</p>
              <p className="text-gray-500 text-sm dark:text-gray-400"> {item.desc} </p>
            </div>
          </div>
        ))}
      </div>
      */}
      <div className="mt-5">
        <button
            onClick={handleLogout} 
            className={`p-3 w-full bg-teal-400 rounded-lg text-white hover:drop-shadow-xl`}
            >
            Cerrar sesión
        </button>
      </div>
    </div>

  );
};

export default UserProfile;
